import React from "react";
import { Dropdown } from "../../common/components/dropdown/Dropdown";
import useFormComponentState from "../../common/forms/useFormComponentState";
import { useClientState } from "../../common/useClientState";
import useSearchState from "../useSearchState";
import useSearch from "./useSearch";
import { dropdownItemsType } from "../../common/types/search/search";

interface LayoutSwitcherProps {
	clearSearchOnChange?: boolean;
	criterionKey: string;
	disabled?: boolean;
	dropdownItems: dropdownItemsType;
	saveToClientState?: boolean;
}

export function LayoutSwitcher({
	criterionKey,
	dropdownItems,
	clearSearchOnChange,
	saveToClientState,
	disabled = false,
}: LayoutSwitcherProps) {
	const { currentInput, onInputChange, onInputChangeAndSearch } =
		useFormComponentState(criterionKey, "");
	const dropdownToggle =
		dropdownItems.find((item) => item.key === currentInput)?.value ||
		dropdownItems[0].value;
	const { onClearResult } = useSearch();
	const { resultExists } = useSearchState([""]);
	const { onChangeClientState } = useClientState(
		criterionKey,
		saveToClientState,
	);

	const handleDropdownItemClick = (input) => {
		if (!resultExists) {
			onInputChange(input);
			return;
		}

		clearSearchOnChange && onClearResult();
		onInputChangeAndSearch(input);
		onChangeClientState(input);
	};

	if (disabled) {
		return null;
	}

	return (
		<div className="actions__action align-center">
			<div className="flex info--text">
				<p>Layout</p>

				<Dropdown
					dropdownToggle={dropdownToggle}
					dropdownItems={dropdownItems}
					onDropdownItemClick={handleDropdownItemClick}
					additionalClasses={{
						dropdown: "dropdown--light dropdown--right",
					}}
					dropdownKey={criterionKey}
				/>
			</div>
		</div>
	);
}
